import { Epic, ofType } from "redux-observable";
import { RootState } from "../../store";
import * as authSelectors from "../auth/authSelectors";
import * as tagActions from "./tagActions";
import { ServiceContainer } from "../../serviceContainer";
import { catchError, exhaustMap, map } from "rxjs/operators";
import { of } from "rxjs";

export const tagForOrganization: Epic<any, any, RootState, ServiceContainer> = (
  action$,
  state$,
  services
) =>
  action$.pipe(
    ofType(tagActions.GET_TAGS_FOR_ORGANIZATION),
    exhaustMap((action: tagActions.GetTagsForOrganizationAction) => {
      const state = state$.value;

      return services.apiTag
        .listByOrganization(
          authSelectors.accessToken(state),
          action.organization
        )
        .pipe(
          map((x) =>
            tagActions.getTagsForOrganizationSuccessAction(
              action.organization,
              x.tags.items
            )
          ),
          catchError(() => {
            services.toastr.error(
              "VenueTag fetch fail",
              "There was error while fetching organization tags"
            );
            return of(
              tagActions.getTagsForOrganizationFailAction(action.organization)
            );
          })
        );
    })
  );
